import { Select } from 'antd';
import { useState, memo, useCallback } from 'react';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import { throttle } from 'lodash-es';
import { querySpuLabel } from '@knowledge/service/api/spu';
import { useMount } from 'ahooks';
import { useSearchTag } from './state';

function LabelSelect() {
  const { t } = useTranslate();
  const [data, setData] = useState<{ label: string; value: string }[]>([]);
  const [value, setValue] = useSearchTag();

  useMount(() => {
    handleSearch('');
  });

  const handleSearch = throttle(async (value: string) => {
    querySpuLabel({ tagName: value, pageInfo: { pageSize: 99999, pageNo: 1 } }).then((res) => {
      setData(
        res.tagData.map((item) => ({
          label: item.tagName,
          value: item.tagId,
        })),
      );
    });
  }, 500);

  const handleChange = (newValue: number[]) => {
    setValue(newValue);
  };

  const maxTagPlaceholderRender = useCallback(
    (omittedValues) => {
      return t('knowledge.item.etc', { x: omittedValues.length });
    },
    [t],
  );

  return (
    <Select
      showSearch
      mode="multiple"
      maxTagCount={1}
      maxTagTextLength={4}
      maxTagPlaceholder={maxTagPlaceholderRender}
      value={value}
      title={!value?.length ? t('knowledge.item.select.search.label') : undefined}
      placeholder={t('knowledge.item.select.search.label')}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={null}
      options={data}
      className={css`
        flex: 0 1 198px;
      `}
    />
  );
}

export default memo(LabelSelect);
